import type { ComponentType } from "react";

import styled from "styled-components";

const CellOpacityWrapper = styled.div<{ opacity: number }>`
    opacity: ${({ opacity }) => opacity};
`;

export const WithCellOpacityHOC = <P extends object>(Component: ComponentType<P>, opacity: number) => {
    const WrappedComponent = (props: P) => {
        return (
            <CellOpacityWrapper opacity={opacity}>
                <Component {...props} />
            </CellOpacityWrapper>
        );
    };

    return WrappedComponent;
};
